import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { S as Sheet } from '../Sheet/Sheet-DnI5My2U.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

/* SSR workaround for nodejs, things like Element don't exists in nodejs. */
const NodeSafeElement = typeof Element !== 'undefined' ? Element : Object;
class BottomSheet extends PureComponent {
  render() {
    const {
      bottomSheetElementId,
      taktId,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(Sheet, _extends({}, rest, {
      sheetElementId: bottomSheetElementId,
      side: "bottom",
      taktId: taktId || createStormTaktId('bottom-sheet')
    }));
  }
}
_defineProperty(BottomSheet, "propTypes", {
  /**
   * The React nodes/nodes that are rendered as content of the BottomSheet.
   */
  children: PT.node.isRequired,
  /**
   * This configures the close button for the bottom sheet. Setting the type property will display
   * the corresponding type of close button above the bottom sheet. A type of icon will render the
   * "X" icon. A type of message will render the string value of the label property. The label is
   * read by a screen reader when the close button is in focus. Both type and label are required.
   */
  closeButton: PT.shape({
    type: PT.oneOf(['icon', 'message']).isRequired,
    label: PT.string.isRequired
  }).isRequired,
  /**
   * Props that are applied to the CloseButton component.
   */
  closeButtonProps: PT.objectOf(PT.any),
  /**
   * A passthrough prop that allows the BottomSheet Shroud to be customized by wrapping the
   * BottomSheet in a styled-component.
   */
  className: PT.string,
  /**
   * This should correspond to the ROOT level dom node id that the modal will render into.
   * When this prop is not explicitly passed a value, the modal will mount the bottom sheet into
   * the div with id matching the portalElementId property in the popover object of the theme.
   */
  bottomSheetElementId: PT.string,
  /**
   * Control open / close of bottom sheet. It will animate automatically on change.
   */
  isOpen: PT.bool,
  /**
   * Fired when any close action occurs, such as: clicking on the background, hitting the close
   * button, or hitting escape.
   */
  onClose: PT.func,
  /**
   * Pass a ref to an element here to use as the toggle element. Focus will move back to this
   * element when the bottom sheet closes.
   */
  toggleEl: PT.oneOfType([PT.instanceOf(NodeSafeElement), PT.shape({
    current: PT.instanceOf(NodeSafeElement)
  })]),
  /**
   * Sets the BottomSheet background color.
   */
  type: PT.oneOf(['light', 'dark', 'blue']),
  transitionDuration: PT.number
});
_defineProperty(BottomSheet, "defaultProps", {
  bottomSheetElementId: undefined,
  className: '',
  closeButtonProps: undefined,
  isOpen: false,
  onClose: undefined,
  toggleEl: undefined,
  type: 'light',
  transitionDuration: 200
});

export { BottomSheet as B };
//# sourceMappingURL=BottomSheet-BNHnqIjL.js.map
